import { applyMiddleware, createStore, combineReducers, compose } from "redux";
import { createMigrate, persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // defaults to localStorage for web
import { connectRouter, routerMiddleware } from "connected-react-router";
import { createBrowserHistory } from "history";

import defaults from "./reducers/defaults";
import order from "./reducers/order";
// import userReducer from "./reducers/userReducer";

// https://github.com/supasate/connected-react-router/issues/266
const migrations = {
  0: state => {
    const { router, ...restOfState } = state;
    return restOfState;
  }
};

const persistConfig = {
  key: "root",
  storage,
  blacklist: ["defaults", "router"],
  migrate: createMigrate(migrations, { debug: true })
};

export const history = createBrowserHistory();

const allReducers = combineReducers({
  defaults,
  order,
  router: connectRouter(history)
  // users: userReducer
});

const persistedReducer = persistReducer(persistConfig, allReducers);

const initialState = {
  order: { items: [] },
  defaults: { color: null, system: null }
};

export default () => {
  let store = createStore(
    persistedReducer,
    initialState,
    compose(
      applyMiddleware(routerMiddleware(history))
      // window.__REDUX_DEVTOOLS_EXTENSION__ &&
      //   window.__REDUX_DEVTOOLS_EXTENSION__()
    )
  );
  const persistor = persistStore(store);
  return { store, persistor };
};
